import blackicon from "../../public/assets/person-black.svg";
import blueicon from "../../public/assets/person-blue.svg";
import greenicon from "../../public/assets/person-green.svg";
import orangeicon from "../../public/assets/person-orange.svg";
import pinkicon from "../../public/assets/person-pink.svg";
import yellowicon from "../../public/assets/person-yellow.svg";
import burst from "../../public/assets/person-purple-burst.svg";

const type = "bar";
const stack = true;
const colorTransparent = "rgba(255, 255, 255, 0)";
// const splitLineColor = "#cac6d4";

const fiftyPercentLineColor = "#333";
const axisLabelColor = "#000";
const fontFamily = 'Whyte, sans-serif';

export const isSmallScreen = window.innerWidth < 600;
export const isMediumScreen =
  window.innerWidth >= 426 && window.innerWidth < 769;
export const isLargeScreen = window.innerWidth >= 769;
const barWidth = isSmallScreen ? 19 : 24;
const splitLineColor = isSmallScreen ? "transparent" : "#cac6d4";
export const barLabelProps = {
  label: {
    fontSize: isSmallScreen || isMediumScreen ? 13 : 18,

  }
};

const iconPaths = [
  "",
  blackicon,
  blueicon,
  greenicon,
  yellowicon,
  orangeicon,
  pinkicon,
  burst
];

// export const customColors = [
//   "rgba(255, 255, 255, 0)",
//   "#221649", // Purple
//   "#4BA3B7", // Blue
//   "#367D54", // Green
//   "#FADE4B", // Yellow
//   "#EB5534", // Orange
//   "#ED7ACA" // Pink
// ];
export const customColors = [
  "rgba(255, 255, 255, 0)",
  "#367D54", // Green
  "#e8c81d", // Yellow
  "#221649", // Purple
  "#4BA3B7", // Blue
  "#ED7ACA", // Pink
  "#EB5534" // Orange
];

export const stepFivePurpleColors = [
  customColors[1],
  customColors[1],
  customColors[4],
  customColors[3],
  customColors[6],
  customColors[2]
];

export const stepFiveOrangeColors = [
  customColors[5],
  customColors[5],
  customColors[4],
  customColors[3],
  customColors[6],
  customColors[2]
];

export const fiftyPercentLine = {
  silent: true,
  lineStyle: {
    color: fiftyPercentLineColor,
    type: "dashed",
    width: 3,
    opacity: 0.15
  },
  label: {
    show: false
  },
  symbolSize: 0,
  data: [
    {
      symbolOffset: [5, 5],
      y: 10,
      xAxis: 50
    }
  ],
  animation: false
};

export const genericProps = {
  type,
  barWidth,
  stack,
  silent: true,
  animation: true,
  animationEasing: "circularOut",
  animationEasingUpdate: "circularOut",
  animationDuration: 1000,
  animationDelay: function (idx) {
    return idx * 75;
  },
  animationDelayUpdate: function (idx) {
    return idx * 50;
  },
  itemStyle: {
    borderColor: '#cac6d4',    
    borderWidth: 0.5,         
    borderType: 'solid'     
  }
};



export const emptyDataObj = {
  value: null,
  itemStyle: {
    color: colorTransparent,
  }
};

const iconStyleNames = [
  "",
  "purple",
  "blue",
  "green",
  "yellow",
  "orange",
  "pink",
  "purpleBurst"
];

const iconFadeStyleNames = [
  "",
  "purpleFade",
  "blueFade",
  "greenFade",
  "yellowFade",
  "orangeFade",
  "pinkFade",
  "purpleBurstFade"
];

const iconSpaces = {
  sm: [
    "",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
    "                  ",
    "          "
  ],
  md: ["", "    ", "    ", "    ", "    ", "   ", "   ", "  "]
};
const iconTextSpaces = {
  sm: ["", "          ", "              ", "           ", "          ", "        ", "              ", "        "],
  md: ["", "     ", "         ", "      ", "     ", "    ", "          ", " "]
};

function getIconStyles(hasVotingEnded) {
  let iconStyleProps = {};
  let iconFadeStyleProps = {};
  const textFade = {
    opacity: hasVotingEnded ? 0.05 : 0.2,
    fontWeight: 700,
    fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
    fontFamily
  };

  iconPaths.forEach((iconPath, i) => {
    const burstIconHeightLarge = 50;
    const burstIconHeightSmall = 42;
    const iconHeightLarge = 22;
    const iconHeightSmall = 17;
    let iconHeight;
    let iconBurstHeight;

    if (isSmallScreen || isMediumScreen) {
      iconHeight = iconHeightSmall;
      iconBurstHeight = burstIconHeightSmall;
    } else {
      iconHeight = iconHeightLarge;
      iconBurstHeight = burstIconHeightLarge;
    }

    const updatedIconStyleProps = {
      backgroundColor: {
        image: iconPath
      },
      height: i === 7 ? iconBurstHeight : iconHeight,
      align: "right"
    };
    iconStyleProps = {
      ...iconStyleProps,
      ...{
        [iconStyleNames[i]]: {
          ...updatedIconStyleProps
        }
      }
    };
    iconFadeStyleProps = {
      ...iconFadeStyleProps,
      ...{
        [iconFadeStyleNames[i]]: {
          ...updatedIconStyleProps,
          ...textFade
        }
      }
    };
  });
  return { ...iconStyleProps, ...iconFadeStyleProps, textFade };
}

export function formatRounds(ballotRounds, stepValue, label) {
  // Only apply this logic if screen width is below 600px
  if (window.innerWidth >= 100) {
    return ballotRounds;
  }

  let labelPosition = "bottom";
  let labelDistance = 0;
  let isLabelShown = false;
  let labelLayout = {
    hideOverlap: true,
    x: 0,
    dy: 0
  };
  const brLen = ballotRounds.length - 1;

  return ballotRounds.map((round, roundIndex) => {
    const getSum = series => {
      return param => {
        let sum = 0;
        series.forEach(seriesDatum => {
          sum += seriesDatum.data[param.dataIndex].value;
        });
        return param.dataIndex === 0 ? "" : `${sum} ${label}`;
      };
    };

    if (isMediumScreen || isLargeScreen) {
      labelLayout = {
        hideOverlap: true
      };
    }

    if (stepValue === 2 || roundIndex === brLen) {
      isLabelShown = true;
    }

    return Object.assign(round, {
      label: {
        fontFamily,
        show: isLabelShown,
        formatter: stepValue === 1 ? "" : getSum(ballotRounds),
        position: labelPosition,  
        distance: labelDistance,
        align: "left",
        offset: [50, 10] 
      },
      labelLayout: labelLayout
    });
  });
}


export function getChartConfig({ stepValue, hasVotingEnded, axisData, winnerText }) {

  const chartConfig = {

    grid: {
      left: "2%",
      right: "0%",
      bottom: "0%",
      top: isSmallScreen ? "-12.6%" : "-12.8%",
      height: isSmallScreen ? "100%" : "100%",
      width: isSmallScreen ? "100%" : "100%",
      containLabel: true
    },
    
    xAxis: {
      type: "value",
      inverse: false,
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily,
        color: "black",
        fontSize: isSmallScreen || isMediumScreen ? 14 : 18,
        padding: isSmallScreen || isMediumScreen ? [10, 0, 0, 10] : [0, 0, 0, 0],
        formatter: (value) => {
         
          return [0, 25, 50].includes(value) ? `${value}%` : "";
        }
      },
      interval: 25,
      min: 0,
      max: 60
    },


    yAxis: {
      type: "category",
      offset: -10,
      splitLine: {
        show: true,
        lineStyle: {
          width: 3,
          color: splitLineColor
        }
      },
      inverse: true,
      data: axisData,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily,
        color: axisLabelColor,
        fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
        fontWeight: "bolder",
        formatter: (axisLabel, axisIndex) => {
        },

        verticalAlign: "top",
        textAlign: "left",
        rich: {
          ...getIconStyles(hasVotingEnded)
        }
      }
    }
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./src/config/chart-config-v2.js